/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-size[_ngcontent-%COMP%]{min-width:192px!important;height:36px!important}"];
export { styles as styles };
